export const PlusIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1"
        d="M7.285 3.927v6.717M3.927 7.285h6.717"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M1.528 1.528h11.515v11.515H1.528z" />
      </clipPath>
    </defs>
  </svg>
);
